"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var classNames = require('classnames');

var Text = require('../text/text');

var Button = require('../button');

var InfoIcon = require('../infoIcon');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var NOTIFICATION_BANNER_SKINS = {
  STANDARD: 'standard',
  PREMIUM: 'premium',
  ALERT: 'alert',
  SUCCESS: 'success'
};
var NOTIFICATION_BANNER_ICON_TYPES = {
  INFO: 'info',
  ALERT: 'alert'
};

var NotificationBanner = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(NotificationBanner, _React$PureComponent);

  var _super = _createSuper(NotificationBanner);

  function NotificationBanner() {
    _classCallCheck(this, NotificationBanner);

    return _super.apply(this, arguments);
  }

  _createClass(NotificationBanner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          getClassName = _this$props.getClassName,
          dataHook = _this$props.dataHook,
          skin = _this$props.skin,
          text = _this$props.text,
          link = _this$props.link,
          icon = _this$props.icon,
          multiline = _this$props.multiline,
          shouldTranslate = _this$props.shouldTranslate;
      var rootClassName = classNames(getClassName('notification-banner'), "notification-banner-skin-".concat(skin));
      /**
       * Text should be in the center and icon should be in the right, so we use 3 divs to achieve it
       * using flex space-between
       * That's why need the empty div and a div container for the icon
       */

      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook,
        className: rootClassName
      }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", {
        className: "notification-banner-contents",
        style: {
          '--maxLines': multiline ? 2 : 1
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "notification-banner-text"
      }, /*#__PURE__*/React.createElement(Text, {
        skin: "secondary",
        size: "small",
        shouldTranslate: shouldTranslate
      }, text)), link && /*#__PURE__*/React.createElement("div", {
        className: "notification-banner-link"
      }, "\xA0", /*#__PURE__*/React.createElement(Button, {
        className: "btn-text link",
        onClick: link.onClick
      }, link.label))), /*#__PURE__*/React.createElement("div", null, icon && /*#__PURE__*/React.createElement(InfoIcon, {
        dataHook: "notification-banner-icon",
        text: icon.tooltipText,
        className: "notification-banner-icon",
        error: icon.type === NOTIFICATION_BANNER_ICON_TYPES.ALERT,
        shouldTranslate: shouldTranslate
      })));
    }
  }]);

  return NotificationBanner;
}(React.PureComponent);

NotificationBanner.displayName = displayNames.NOTIFICATION_BANNER;
NotificationBanner.propTypes = {
  /** Hook for testing purposes */
  dataHook: PropTypes.string,

  /** Notification label */
  text: PropTypes.string.isRequired,

  /** Changes visual theme */
  skin: PropTypes.oneOf(Object.values(NOTIFICATION_BANNER_SKINS)),

  /** Make text up to 2 lines if needed */
  multiline: PropTypes.bool,

  /** Display an info icon */
  icon: PropTypes.shape({
    type: PropTypes.oneOf(Object.values(NOTIFICATION_BANNER_ICON_TYPES)),
    tooltipText: PropTypes.string
  }),

  /** Link */
  link: PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
  }),
  shouldTranslate: PropTypes.bool
};
NotificationBanner.defaultProps = {
  skin: NOTIFICATION_BANNER_SKINS.STANDARD,
  multiline: false
};
module.exports = compose(NotificationBanner);